import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-refetch'
import { checkNextPropsPromiseFulfilled, connectDefault } from '../utils/utils'
import * as actions from '../actions/index'
import * as styles from '../styles/styles'
import { Button, Dialog, DialogContent, DialogActions, DialogTitle } from 'react-mdl'

import AppChannels from '../components/AppChannels'
import Settings from '../components/Settings'

class Overview extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  static propTypes = {
    location: PropTypes.object.isRequired,
    appBaseURL: PropTypes.string.isRequired,
    ahBaseUrl: PropTypes.string.isRequired,
    appJWT: PropTypes.string.isRequired,
    app: PropTypes.object.isRequired,
    fetchApp: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    channelTypes: PropTypes.array.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.state = {
      settingsDialogVisible:false,
      deleteAppDialogVisible: false
    };

    this.handleOpenDeleteAppDialog = this.handleOpenDeleteAppDialog.bind(this);
    this.handleOpenSettingsDialog = this.handleOpenSettingsDialog.bind(this);
    this.handleCloseDialogs = this.handleCloseDialogs.bind(this);
    this.saveApp = this.saveApp.bind(this);
  }

  componentWillMount(){
    this.props.dispatch(
        actions.setTopbarButtons([
          { key:"APP_EDIT",   title: "Edit",   icon: "edit",   action: this.handleOpenSettingsDialog },
          { key:"APP_DELETE", title: "Delete", icon: "delete", action: this.handleOpenDeleteAppDialog }
        ])
    )
  }

  componentWillReceiveProps(nextProps) {
    //saving
    if (checkNextPropsPromiseFulfilled(this.props, nextProps, 'putAppResponse')) {
      this.handleCloseDialogs()
      this.props.fetchApp()
    }
    //delete
    else if (checkNextPropsPromiseFulfilled(this.props, nextProps, 'deleteAppResponse')) {
      this.goBack()
    }
  }

  handleOpenSettingsDialog() {
    const state = this.settings.defaultState()
    this.settings.setState(state)
    this.setState({
      settingsDialogVisible: true
    });
  }

  handleOpenDeleteAppDialog() {
    this.setState({
      deleteAppDialogVisible: true
    });
  }

  handleCloseDialogs() {
    this.setState({
      settingsDialogVisible: false,
      deleteAppDialogVisible: false
    });
  }

  saveApp() {
    const { title } = this.settings.state

    if (title === ""){
      return
    }

    const { app } = this.props

    const updatedApp = {
      account: app.account,
      id: app.id,
      title: title
    }

    this.props.saveApp(updatedApp)
  }

  render() {
    const { location, ahBaseUrl, app, dispatch, channelTypes, appJWT } = this.props

    return (
      <div>
        <Dialog open={this.state.deleteAppDialogVisible}>
          <DialogContent>
            <p>Are you sure you want to delete this brand?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>this.props.deleteApp(this.props.app)} style={styles.button.delete}>Delete</Button>
            <Button onClick={this.handleCloseDialogs}>Cancel</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.settingsDialogVisible}>
          <DialogTitle>Settings</DialogTitle>
          <DialogContent>
            <Settings ref={(input) => this.settings = input} fields={[{name:"title",label:"Title",value:app.title}]}/>
          </DialogContent>
          <DialogActions>
            <Button colored onClick={this.saveApp}>Save</Button>
            <Button onClick={this.handleCloseDialogs}>Dismiss</Button>
          </DialogActions>
        </Dialog>

        <AppChannels location={location} ahBaseUrl={ahBaseUrl} channelTypes={channelTypes} dispatch={dispatch} appJWT={appJWT}/>
      </div>
    )
  }

  goBack() {
    const pathComponents = this.props.location.pathname.split("/");
    pathComponents.splice(pathComponents.length-2, 2);
    const path = pathComponents.join("/")
    this.context.router.push(path);
  }

}

export default connect.defaults(connectDefault)(props => {
  return {
    saveApp: app => ({
      putAppResponse: {
        title: 'Update App',
        dispatch: props.dispatch,
        url: `${props.appBaseURL}`,
        method: 'PUT',
        body: app
      }
    }),
    deleteApp: app => ({
      deleteAppResponse: {
        title: 'Delete App',
        dispatch: props.dispatch,
        url: `${props.appBaseURL}`,
        refreshing: true, force: true,
        method: 'DELETE'
      }
    })
  }
})(Overview)



// WEBPACK FOOTER //
// ./src/components/AppOverview.js